import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationJobs.views.FabricationJobPicker.';
  public static readonly selectFabricationJob = `${Id.prefix}selectFabricationJob`;
  public static readonly searchPlaceholder = `${Id.prefix}searchPlaceholder`;
  public static readonly loading = `${Id.prefix}loading`;
  public static readonly noJobsFound = `${Id.prefix}noJobsFound`;
  public static readonly cancel = `${Id.prefix}cancel`;
  public static readonly createNewJob = `${Id.prefix}createNewJob`;
  public static readonly itemCount = `${Id.prefix}itemCount`;
}

export class LangFabricationJobPicker {
  private constructor() {}
  public static selectFabricationJob(): string {
    return interpolate(Id.selectFabricationJob);
  }
  public static searchPlaceholder(): string {
    return interpolate(Id.searchPlaceholder);
  }
  public static loading(): string {
    return interpolate(Id.loading);
  }
  public static noJobsFound(): string {
    return interpolate(Id.noJobsFound);
  }
  public static cancel(): string {
    return interpolate(Id.cancel);
  }
  public static createNewJob(): string {
    return interpolate(Id.createNewJob);
  }
  public static itemCount(count: number): string {
    return interpolate(Id.itemCount, { count: count.toString() });
  }
}

export class FabricationJobPickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.selectFabricationJob, 'Select Fabrication Job', 'Dialog title for selecting a fabrication job');
    register.add(Id.searchPlaceholder, 'Search jobs...', 'Placeholder text for fabrication job search input');
    register.add(Id.loading, 'Loading...', 'Loading indicator text');
    register.add(Id.noJobsFound, 'No Draft jobs found.', 'Message when no draft fabrication jobs are available');
    register.add(Id.cancel, 'Cancel', 'Button label for cancelling the dialog');
    register.add(Id.createNewJob, '+ Create New Job', 'Button label for creating a new fabrication job');
    register.add(Id.itemCount, '{{count}} items', 'Badge showing the number of items in a fabrication job');
  }
}
